<script setup>
import { trans } from '@tools/translation';
</script>

<template>
  <span class="hit-label hit-label--contacted">
    {{ trans('offer_card.labels.contacted') }}
  </span>
</template>
